__webpack_require__.p = "/vue-atomic-design/";